export class Main {
    constructor() {
        this.windowWidth = 0;
        this.windowWidthThen = 0;


        // Corporate Movie モーダルウインドウ (Jstream)
        this.playerMain = {};
        this.initMainMovFlg = false; //初回表示

        // Corporate Bg Loop Movie (Jstream)
        this.bgMovPc = "OTI2"; //PC
        this.bgMovSp = "OTI3"; //SP
        this.playerPc = {}; //PC
        this.playerSp = {}; //SP jstreamはplayerにあとからloadできない?
        this.playerReadyPc = false;
        this.playerReadySp = false;


        // モーダルウインドウ　Close Btn
        this.corpMovBtn = {};
        this.openModalFlg = false;


    }



    initMov() {
        // Jstream Player ------
        this.playerSp = window.jstream_t3.PlayerFactoryIF.create({
            b: "eqa940luwj.eq.webcdn.stream.ne.jp/www50/eqa940luwj/jmc_pub/jmc_swf/player/",
            c: "MTMxNQ==",
            m: this.bgMovSp,
            s: {
                dq: 4, //Default Quality
                mdq: 4, //Mobile Quality
                hp: 950,
                il: "off",
                rp: "fit", //Responsive
                lu: "on", //loop_use
                pr: "0.5,0.7,1.2,1.5,2.0",
                pb: "off", //Play Button
                sn: "",
                tg: "off",
                ti: "off", //Title
                wp: 1500,
                wm: "off", //Water Mark 中央再生ボタンの表示有無
                vc: "off", //Volume Control
                sb: "off", //Seek Bar
                fs: "off", //Full Screen
                cp: "off", //Control panel
                is: "off", //Init Sound
                ip: "on" //Init Play 自動再生ON(ip:"on")にしたときにiOSでは自動的にミュート状態に切り替わります https://support.eq.stream.co.jp/hc/ja/articles/115009580027-%E9%85%8D%E4%BF%A1%E6%96%B9%E5%BC%8F
            },
        }, "js-video-jstream-loop-sp");

        this.playerPc = window.jstream_t3.PlayerFactoryIF.create({
            b: "eqa940luwj.eq.webcdn.stream.ne.jp/www50/eqa940luwj/jmc_pub/jmc_swf/player/",
            c: "MTMxNQ==",
            m: this.bgMovPc,
            s: {
                dq: 4, //Default Quality
                mdq: 4, //Mobile Quality
                hp: 750,
                il: "off",
                rp: "fit", //Responsive
                lu: "on", //loop_use
                pr: "0.5,0.7,1.2,1.5,2.0",
                pb: "off", //Play Button
                sn: "",
                tg: "off",
                ti: "off", //Title
                wp: 1920,
                wm: "off", //Water Mark 中央再生ボタンの表示有無
                vc: "off", //Volume Control
                sb: "off", //Seek Bar
                fs: "off", //Full Screen
                cp: "off", //Control panel
                is: "off", //Init Sound
                ip: "on" //Init Play 自動再生ON(ip:"on")にしたときにiOSでは自動的にミュート状態に切り替わります https://support.eq.stream.co.jp/hc/ja/articles/115009580027-%E9%85%8D%E4%BF%A1%E6%96%B9%E5%BC%8F
            },
        }, "js-video-jstream-loop");
        this.playerPc.accessor.addEventListener("landing", () => {
            this.playerReadyPc = true;
            //console.log('playerReadyPc');
            // if (window.innerWidth <= 768) {
            //     console.log('playerReadyPc pause');
            //     this.playerPc.accessor.pause();
            // }

            window.setTimeout(() => {
                this.onResizeMov();
            }, 800);
        });
        this.playerSp.accessor.addEventListener("landing", () => {
            this.playerReadySp = true;
            //console.log('playerReadySp');
            // if (window.innerWidth > 768) {
            //     console.log('playerReadySp pause');
            //     this.playerSp.accessor.pause();
            // }
            window.setTimeout(() => {
                this.onResizeMov();
            }, 800);
        });
        //this.onResizeMov();


        //popup
        this.corpMovBtn = document.querySelector('.development-movie__controller');
        this.corpMovBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.showMainMovModal();
            //console.log('clicked!!');
        });
    }

    showMainMovModal() {
        // Corporate Movie モーダルウインドウ内
        let modal = document.getElementById('js-video-jstream-container-1');
        if (!this.initMainMovFlg) {
            // Jstream Player 
            this.playerMain = window.jstream_t3.PlayerFactoryIF.create({
                b: "eqa940luwj.eq.webcdn.stream.ne.jp/www50/eqa940luwj/jmc_pub/jmc_swf/player/",
                c: "MTMxNQ==",
                m: "ODA5",
                s: {

                    dq: "5",
                    hp: 1080,
                    il: "off",
                    mdq: "2",
                    pr: "0.5,0.7,1.2,1.5,2.0",
                    sn: "",
                    tg: "off",
                    ti: "off",
                    wp: 1920,

                    cc: "off",
                    el: "off",
                    //hp: 360,
                    //il: "off",
                    mb: "off",
                    rp: "fit",
                    //sn: "",
                    //tg: "off",
                    //ti: "off",
                    //wp: 640,
                    is: "on",
                    ip: "off" //iOS 自動再生ON(ip:”on”)にしたときに自動的にミュート状態に切り替わります https://support.eq.stream.co.jp/hc/ja/articles/115009580027-%E9%85%8D%E4%BF%A1%E6%96%B9%E5%BC%8F
                },
            }, "js-video-jstream-1");

            //close btn
            let btn = modal.querySelector('.jstream__close-btn');
            btn.addEventListener('click', (event) => {
                //console.log('cewfcewfe');
                this.playerMain.accessor.pause();
                event.preventDefault();
                this.hideMainMovModal();
            });
        }


        this.body.classList.add('is-modal-show');
        modal.classList.add('is-show');

        this.initMainMovFlg = true;
        this.openModalFlg = true;

        this.onResizeMov();
    }

    hideMainMovModal() {
        this.body.classList.remove('is-modal-show');
        document.getElementById('js-video-jstream-container-1').classList.remove('is-show');
        //this.playerPc.accessor.play();
        //this.playerSp.accessor.play();
        //this.player.play();
        // this.movLoopPlay = true;
        this.openModalFlg = false;
        this.onResizeMov();
    }



    onResizeMov() {
        //console.log('onResizeMov');
        // checkBgMovSizeAndPlay
        // Jstream ウインドウサイズチェック + SP/PCのどちらを表示するかチェック + 再生すべきかチェック
        this.windowWidth = window.innerWidth; //document.documentElement.clientWidth;
        if (this.windowWidth > 1000) {
            //PC
            document.getElementById('js-video-jstream-loop').classList.remove('hide');
            document.getElementById('js-video-jstream-loop-sp').classList.add('hide');
            if (this.openModalFlg) {
                //モーダルウインドウ オープン時
                this.playerSp.accessor.pause();
                this.playerPc.accessor.pause();
            } else {
                //モーダルウインドウが閉じている
                //console.log(this.playerReadyPc);
                this.playerSp.accessor.pause();
                if (this.playerReadyPc) {
                    this.playerPc.accessor.play();
                }
            }
        } else {
            //SP
            document.getElementById('js-video-jstream-loop').classList.add('hide');
            document.getElementById('js-video-jstream-loop-sp').classList.remove('hide');
            if (this.openModalFlg) {
                //モーダルウインドウ オープン時
                this.playerSp.accessor.pause();
                this.playerPc.accessor.pause();
            } else {
                //モーダルウインドウが閉じている
                //console.log(this.playerReadySp);
                this.playerPc.accessor.pause();
                if (this.playerReadySp) {
                    this.playerSp.accessor.play();
                }
            }
        }
        // console.log('onResizeMov');
    }


    init() {

        // DOMContentLoaded時
        // ------------------------------
        window.addEventListener('DOMContentLoaded', () => {

            this.body = document.getElementsByTagName('body')[0];
            this.html = document.getElementsByTagName('html')[0];

            // スクロール時
            window.addEventListener('scroll', () => {
                //this.scrChecker.onUpdate();
            });

            // ウインドウリサイズ時
            window.addEventListener('resize', () => {
                //this.scrChecker.onUpdate();
                if (this.timerResized !== false) {
                    //clearTimeout(this.timerResized);
                }
                this.timerResized = setTimeout(() => {
                    //this.dmenu.envCheck();
                    //this.scrChecker.onResizeMov();
                    //this.accordions.accResize();
                    this.onResizeMov();
                }, 300);
            });


            this.windowWidthThen = window.innerWidth;

            // Corporate Movie
            if (document.getElementById('js-video-jstream-loop')) { //js-index-movie-loop
                //let videoElem = document.getElementById('js-index-movie-loop');
                this.initMov();
            }

        });

        // load時
        // ------------------------------
        // window.addEventListener("load", () => {
        //     window.setTimeout(() => {
        //     }, 400);
        //     window.setTimeout(() => {
        //     }, 300);
        // });
    }
}